// import React, { useState, useEffect } from "react";
// import { motion } from "framer-motion";
// // import { useLoader } from "../context/LoaderProvider";
// import { FaEye, FaEyeSlash } from "react-icons/fa";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";


// // Import your images
// import img0 from "../../images/reavanue.png";
// import img1 from "../../images/trust.png";
// import img2 from "../../images/cost.png";
// import img3 from "../../images/digital.png";
// import img4 from "../../images/notifaction.png";
// import img5 from "../../images/reputaction.png";
// import img6 from "../../images/globel.png";
// import img7 from "../../images/sequrees.webp";
// import img8 from "../../images/multiuser.png";
// import img9 from "../../images/loyalty.png";
// import img10 from "../../images/boots.png";
// import img11 from "../../images/installment.png";



// const DigitalMenuSection = ({ setShowLogin, setIsSignup, scrollToCTA, openDemoModal }) => {
//   const sections = [
//     {
//       title: "Digital Billing & POS",
//       desc: [
//         "Instant digital invoices",
//         "Multi-payment modes",
//         "Real-time billing dashboard"
//       ],
//       img: img3,
//       features: [
//         "Generate professional invoices instantly",
//         "Auto-record every transaction safely in the cloud",
//         "Maintain error-free financial history",
//         "Export reports anytime for GST filing, audits, or accounts",
//         "Track payments received / pending / cancelled",
//       ],
//       result:
//         "Save time, reduce errors, and operate with complete transparency",
//     },
//     {
//       title: "Live Order Management",
//       desc: [
//         "Track orders in real-time",
//         "Status updates for staff",
//         "Order history & analytics"
//       ],
//       img: img1,
//       features: [
//         "Book services and order food in one app",
//         "Plan events and travel",
//         "Access multiple lifestyle services seamlessly",
//         "Your brand identity and business information",
//         "Product or service menus, pricing, and photos",
//         "Real-time updates, offers, and announcements",
//         "Customer reviews & direct communication",
//         "A professional digital business profile",
//         "Online visibility to reach more customers",
//         "Instant messaging & direct engagement",
//         "Improved trust and stronger brand identity",
//         "More conversions and higher revenue"
//       ],
//     },
//     {
//       title: "Instant Order Notifications",
//       desc: [
//         "Push alerts on new orders",
//         "Kitchen & staff notifications",
//         "Customer order confirmations"
//       ],
//       img: img4,
//       features: [
//         "New customer orders",
//         "Bookings & reservations",
//         "Customer support inquiries",
//         "Payment updates & status changes",
//       ],
//       result:
//         "Faster response, zero delays, increased customer satisfaction.",

//     },
//     {
//       title: "Secure Payment Integration",
//       desc: [
//         "Multiple payment gateways",
//         "UPI, Cards, Wallets",
//         "Automated reconciliation"
//       ],
//       img: img7,
//       features: [
//         "UPI / Cards / Wallets / Net Banking / COD",
//         "Instant payment confirmation",
//         "Zero payment confusion or disputes",
//       ],
//       result:
//         "Faster payments = Faster business growth.",

//     },
//     {
//       title: "Customer Reviews & Ratings",
//       desc: [
//         "Collect feedback instantly",
//         "Respond to reviews",
//         "Build trust & reputation"
//       ],
//       img: img5,
//       features: [
//         "Honest reviews from real customers",
//         "High ratings boost your ranking in search results",
//         "Improves repeat customers & referrals",
//         "Builds strong digital identity & credibility",
//       ],
//       result:
//         "People choose businesses they trust — reviews make the difference.",

//     },


//     {
//       title: "Multi-User Access",
//       desc: [
//         "Role-based permissions",
//         "Staff account management",
//         "Activity tracking"
//       ],
//       img: img8,
//       features: [
//         "👥 Add team members with role-based permissions",
//         "🔒 Control access for security",
//         "📝 Track logins, activities, and updates",
//       ],
//       result:
//         "Perfect for restaurants, retail stores, salons, and service centers.",


//     },

//     {
//       title: "Promotions & Loyalty Tools",
//       desc: [
//         "Custom discount campaigns",
//         "Loyalty point programs",
//         "Targeted offers"
//       ],
//       img: img9,
//       features: [
//         "🎁 Reward points & membership benefits",
//         "🎉 Festival and seasonal promotions",
//         "🏷 Coupons, discounts & offer codes",
//         "📣 Boost engagement & increase lifetime customer value",
//       ],
//       result:
//         "Enhance customer loyalty and maximize repeat business.",


//     },

//     {
//       title: "Business Reports & Insights",
//       desc: [
//         "Daily/weekly/monthly reports",
//         "Revenue analytics",
//         "Customer behavior data"
//       ],
//       img: img6,
//       features: [
//         "Track sales daily, weekly, monthly",
//         "Understand customer buying behaviour",
//         "Identify best-selling items or services",
//         "Know peak hours and demand seasons",
//       ],
//       result:
//         "Smarter strategies, better planning, and higher profits.",

//     },


//     {
//       title: "No Hardware Required",
//       desc: [
//         "Runs on any mobile or laptop",
//         "Cloud-based platform",
//         "Access from anywhere"
//       ],
//       img: img11,
//       features: [
//         "📱 Smartphone",
//         "💻 Laptop",
//         "📟 Tablet or POS system",
//       ],
//       result:
//         "No servers, cables, maintenance, or IT installation required.",



//     },


//     {
//       title: "Easy Setup & Quick Onboarding",
//       desc: [
//         "Go live in minutes",
//         "Guided setup wizard",
//         "Dedicated support team"
//       ],
//       img: img2,
//       features: [
//         "Complete digital storefront",
//         "Order, booking & customer management",
//         "Billing, payments & financial tracking tools",
//         "Reviews, ratings & promotional features",
//         "Analytics & performance insights",
//         "Multi-user access for your business team",
//       ],

//     },

//   ];



//   const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
//   const [expandedFeatures, setExpandedFeatures] = useState(
//     Array(sections.length).fill(false)
//   );

//   useEffect(() => {
//     const handleResize = () => setIsMobile(window.innerWidth < 768);
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const toggleFeature = (index) => {
//     const updated = [...expandedFeatures];
//     updated[index] = !updated[index];
//     setExpandedFeatures(updated);
//   };

//   const openSignup = () => {
//     setShowLogin(true);
//     setIsSignup(true);
//   };

//   return (
//     <div style={styles.container}>
//       {/* MAIN HEADER */}
//       <div style={styles.header}>
//         <motion.div
//           initial={{ opacity: 0, y: -20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.8 }}
//           style={{ position: "relative", display: "inline-block" }}
//         >
//           <p style={styles.mainHeading}>
//             Core Features
//           </p>

//           <motion.div
//             initial={{ width: 0 }}
//             animate={{ width: "70%" }}
//             transition={{ duration: 1, delay: 0.4, ease: "easeOut" }}
//             style={{
//               height: "2px",
//               background: "#e66d33",
//               borderRadius: "4px",
//               marginTop: "6px",
//               marginLeft: "auto",
//               marginRight: "auto",
//             }}
//           />
//         </motion.div>
//         <p style={{ color: "#000", marginTop: "10px" }}>Powerful tools designed specifically for food businesses.</p>
//       </div>

//       {/* SECTIONS */}
//       <div style={styles.sectionsWrapper}>
//         {sections.map((section, index) => (
//           <motion.div
//             key={index}
//             initial={{ x: index % 2 === 0 ? -50 : 50, opacity: 0, scale: 0.95 }}
//             whileInView={{ x: 0, opacity: 1, scale: 1 }}
//             transition={{ duration: 0.7, ease: "easeOut", delay: index * 0.1 }}
//             viewport={{ once: true, margin: "-50px" }}
//             style={{
//               ...styles.sectionContainer,
//               marginBottom: index === sections.length - 1 ? "0" : "20px",
//               flexDirection: isMobile ? "column" : index % 2 === 0 ? "row" : "row-reverse",
//             }}
//           >
//             {/* IMAGE */}
//             <div style={styles.imageWrapper}>
//               <div style={styles.imageFrame}>
//                 <img src={section.img} alt={section.title} style={styles.sectionImage} loading="lazy" />
//                 <div
//                   style={{
//                     ...styles.imageDecoration,

//                   }}
//                 />
//               </div>
//             </div>

//             {/* CONTENT */}
//             <div style={styles.contentWrapper}>
//               <div style={styles.contentInner}>
//                 <div style={styles.titleRow}>
//                   <div
//                     style={{
//                       ...styles.titleIcon,
//                       background:
//                         index % 2 === 0
//                           ? "linear-gradient(135deg, #e66d33  0%, #e66d33  100%)"
//                           : "linear-gradient(135deg, #e66d33  0%, #e66d33  100%)",
//                     }}
//                   >
//                     <span style={styles.iconText}>{index + 1}</span>
//                   </div>
//                   <h2 style={styles.sectionTitle}>{section.title}</h2>
//                 </div>

//                 <ul style={styles.featureList}>
//                   {(Array.isArray(section.desc)
//                     ? section.desc
//                     : section.desc.split(".").filter(Boolean)
//                   ).map((line, i) => (
//                     <li key={i} style={styles.featureItem}>
//                       <span style={styles.bullet}></span>
//                       {line}
//                     </li>
//                   ))}
//                 </ul>

//                 {/* BUTTONS */}
//                 <div style={{ display: "flex", gap: "12px", flexWrap: "wrap", marginTop: "auto" }}>

//                   <button
//                     style={{
//                       ...styles.signupBtn,
//                       background:
//                         index % 2 === 0
//                           ? "linear-gradient(135deg, #e66d33  0%, #e66d33  100%)"
//                           : "linear-gradient(135deg, #e66d33  0%, #e66d33  100%)",
//                       padding: isMobile ? "8px 14px" : "2px 6px",
//                       fontSize: isMobile ? "13px" : "16px",
//                       borderRadius: isMobile ? "6px" : "10px",
//                       fontWeight: "700",
//                       marginLeft: "8px"
//                     }}
//                     onClick={scrollToCTA}
//                   >
//                     Book A Demo<span style={styles.arrowBlink}>➜</span>
//                   </button>


//                   {/* KEY FEATURE BUTTON */}
//                   {/* <button
//                     style={{
//                       ...styles.signupBtn,
//                       background: "linear-gradient(135deg, #ff7a18 0%, #af002d 100%)",
//                       padding: isMobile ? "8px 14px" : "12px 22px",
//                       fontSize: isMobile ? "13px" : "16px",
//                       borderRadius: isMobile ? "6px" : "10px",
//                     }}
//                     onClick={() => toggleFeature(index)}
//                   >
//                     Key Features
//                   </button> */}
//                 </div>

//                 {/* EXPANDED FEATURES */}
//                 {expandedFeatures[index] && (
//                   <>
//                     <ul style={styles.featureList}>
//                       {section.features.map((feat, i) => (
//                         <li key={i} style={styles.featureItem}>
//                           {feat}
//                         </li>
//                       ))}
//                     </ul>

//                     {section.result && (
//                       <p style={styles.resultText}>
//                         <strong>Benefits:</strong> {section.result}

//                       </p>
//                     )}
//                   </>
//                 )}


//               </div>
//             </div>
//           </motion.div>
//         ))}
//       </div>
//     </div>
//   );
// };

// const styles = {
//   container: {
//     width: "100%",
//     minHeight: "100vh",
//     // backgroundColor: "#faf9ff",
//     padding: "60px 5%",
//     fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
//     position: "relative",
//     overflow: "hidden",
//   },
//   sectionDescription: {
//     fontSize: "15px",
//     color: "#555",
//     lineHeight: "1.7",
//     marginBottom: "12px",
//     maxWidth: "500px",
//   },
//   header: { textAlign: "center", marginBottom: "32px", marginTop: "-57px", padding: "0 20px" },
//   mainHeading: { fontSize: "clamp(2.7rem, 5vw, 2.7rem)", fontWeight: "800", color: "#222", marginBottom: "20px", letterSpacing: "-1px", lineHeight: "1.1" },
//   highlight: { color: "#e66d33", backgroundClip: "text" },
//   subHeading: { fontSize: "clamp(1.1rem, 2vw, 1.3rem)", color: "#666", maxWidth: "1200px", margin: "0 auto", lineHeight: "1.6", fontWeight: "400", opacity: 0.9 },
//   sectionsWrapper: { maxWidth: "1400px", margin: "0 auto", padding: "20px 0" },
//   sectionContainer: { display: "flex", alignItems: "center", gap: "0px", width: "100%", minHeight: "400px", position: "relative" },
//   imageWrapper: { flex: "1", minWidth: "0", position: "relative" },
//   imageFrame: { position: "relative", height: "270px", overflow: "hidden", borderRadius: "25px" },
//   sectionImage: { width: "100%", height: "100%", objectFit: "contain", transition: "transform 0.6s ease" },
//   imageDecoration: { position: "absolute", top: "20px", left: "20px", right: "-20px", bottom: "-20px", borderRadius: "25px", opacity: 0.1, zIndex: -1, filter: "blur(10px)" },
//   contentWrapper: { flex: "1", minWidth: "0" },
//   contentInner: {
//     padding: "40px",
//     height: "100%",
//     display: "flex",
//     flexDirection: "column",
//     position: "relative", // <-- add this
//   },
//   titleRow: { display: "flex", alignItems: "center", gap: "20px", marginBottom: "25px" },
//   titleIcon: { width: "50px", height: "50px", borderRadius: "12px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, boxShadow: "0 8px 20px rgba(177, 92, 214, 0.2)" },
//   iconText: { color: "white", fontSize: "1.5rem", fontWeight: "700" },
//   sectionTitle: { fontSize: "clamp(1.8rem, 2.5vw, 2.2rem)", fontWeight: "800", color: "#222", margin: 0, letterSpacing: "-0.5px", lineHeight: "1.2" },
//   sectionDescription: { fontSize: "1.05rem", lineHeight: "1.8", color: "#555", marginBottom: "35px", flex: 1, fontWeight: "400" },
//   signupBtn: { border: "none", cursor: "pointer", display: "flex", alignItems: "center", gap: "12px", transition: "transform 0.3s ease", boxShadow: "0px 8px 15px rgba(0,0,0,0.15)" },
//   arrowBlink: { fontSize: "24px", fontWeight: "700", color: "#fff", animation: "arrowBlink 0.8s infinite alternate ease-in-out" },
//   featureList: { marginTop: "15px", paddingLeft: "20px" },
//   featureItem: { marginBottom: "6px", fontSize: "1rem", color: "#333", lineHeight: "1.5" },
// };


// export default DigitalMenuSection;



// import React, { useState, useEffect } from "react";
// import { motion } from "framer-motion";
// // import { useLoader } from "../context/LoaderProvider";
// import { FaEye, FaEyeSlash } from "react-icons/fa";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";


// // Import your images
// import img0 from "../../images/reavanue.png";
// import img1 from "../../images/trust.png";
// import img2 from "../../images/cost.png";
// import img3 from "../../images/digital.png";
// import img4 from "../../images/notifaction.png";
// import img5 from "../../images/reputaction.png";
// import img6 from "../../images/globel.png";
// import img7 from "../../images/sequrees.webp";
// import img8 from "../../images/multiuser.png";
// import img9 from "../../images/loyalty.png";
// import img10 from "../../images/boots.png";
// import img11 from "../../images/installment.png";



// const DigitalMenuSection = ({ setShowLogin, setIsSignup, isLoggedIn, openDemo }) => {
//   const sections = [
//     {
//       title: "Trusted Digital Presence, Wider Reach",
//       desc: "Customers trust what they see online. A professional digital presence immediately improves credibility and decision-making.With Maamaas, your business gets a complete digital storefront that showcases:No need for website development, app building, designers, or technical knowledge.Everything is ready to use from Day 1.Maamaas makes every local business capable of competing with large brands — without heavy investment.",
//       img: img1,
//       features: [
//         "Book services and order food in one app",
//         "Plan events and travel",
//         "Access multiple lifestyle services seamlessly",
//         "Your brand identity and business information",
//         "Product or service menus, pricing, and photos",
//         "Real-time updates, offers, and announcements",
//         "Customer reviews & direct communication",
//         "A professional digital business profile",
//         "Online visibility to reach more customers",
//         "Instant messaging & direct engagement",
//         "Improved trust and stronger brand identity",
//         "More conversions and higher revenue"
//       ],
//     },

//     {
//       title: "Clear, Easy, Cost-Effective",
//       desc: "Instead of commission loss, Maamaas offers a simple yearly subscription plan.No complicated charges. No fluctuating costs. One small yearly subscription for complete control.",
//       img: img2,
//       features: [
//         "Complete digital storefront",
//         "Order, booking & customer management",
//         "Billing, payments & financial tracking tools",
//         "Reviews, ratings & promotional features",
//         "Analytics & performance insights",
//         "Multi-user access for your business team",
//       ],

//     },
//     {
//       title: "Digital Billing. Live Payments.",
//       desc: "Step into the future of business management with seamless digital billing. No more handwritten bills, missing records, or calculation mistakes.With Maamaas:",
//       img: img3,
//       features: [
//         "Generate professional invoices instantly",
//         "Auto-record every transaction safely in the cloud",
//         "Maintain error-free financial history",
//         "Export reports anytime for GST filing, audits, or accounts",
//         "Track payments received / pending / cancelled",
//       ],

//       result:
//         "Save time, reduce errors, and operate with complete transparency",




//     },
//     {
//       title: "Instant Order Alerts",
//       desc: "Stay connected to every customer moment — get instant alerts for orders, bookings, and inquiries whether you're online or offline, so no opportunity is ever missed.",
//       img: img4,
//       features: [
//         "New customer orders",
//         "Bookings & reservations",
//         "Customer support inquiries",
//         "Payment updates & status changes",
//       ],
//       result:
//         "Faster response, zero delays, increased customer satisfaction.",

//     },
//     {
//       title: "Real Reviews, Real Reputation",
//       desc: "Let your work speak for itself — positive customer reviews build trust, boost visibility, and strengthen your business reputation so more people choose you with confidence.",
//       img: img5,
//       features: [
//         "Honest reviews from real customers",
//         "High ratings boost your ranking in search results",
//         "Improves repeat customers & referrals",
//         "Builds strong digital identity & credibility",
//       ],
//       result:
//         "People choose businesses they trust — reviews make the difference.",

//     },
//     {
//       title: "Business Analytics & Growth Insights",
//       desc: "Make smarter business decisions with confidence — real-time insights and data analytics help you understand customer behavior, track performance, and plan the next move with clarity.",
//       img: img6,
//       features: [
//         "Track sales daily, weekly, monthly",
//         "Understand customer buying behaviour",
//         "Identify best-selling items or services",
//         "Know peak hours and demand seasons",
//       ],
//       result:
//         "Smarter strategies, better planning, and higher profits.",

//     },
//     {
//       title: "Flexible & Secure Payment Options",
//       desc: "Offer customers complete payment flexibility — whether via UPI, cards, wallets, or net banking, transactions are fast, secure, and hassle-free every time..",
//       img: img7,
//       features: [
//         "UPI / Cards / Wallets / Net Banking / COD",
//         "Instant payment confirmation",
//         "Zero payment confusion or disputes",
//       ],
//       result:
//         "Faster payments = Faster business growth.",

//     },
//     {
//       title: "Multi-User Access for Teams",
//       desc: "Streamline staff management with digital tools — assign tasks, monitor performance, and stay in full control, all from one easy-to-use platform..",
//       img: img8,
//       features: [
//         "👥 Add team members with role-based permissions",
//         "🔒 Control access for security",
//         "📝 Track logins, activities, and updates",
//       ],
//       result:
//         "Perfect for restaurants, retail stores, salons, and service centers.",


//     },
//     {
//       title: "Customer Loyalty & Promotional Tools",
//       desc: "Boost customer loyalty by providing seamless experiences and personalized engagement, encouraging them to return again and again.",
//       img: img9,
//       features: [
//         "🎁 Reward points & membership benefits",
//         "🎉 Festival and seasonal promotions",
//         "🏷 Coupons, discounts & offer codes",
//         "📣 Boost engagement & increase lifetime customer value",
//       ],
//       result:
//         "Enhance customer loyalty and maximize repeat business.",


//     },
//     {
//       title: "Marketing & Local Discovery Boost",
//       desc: "Get noticed and stay ahead of the competition — Maamaas increases your business visibility online, helping you reach more customers without extra marketing costs.",
//       img: img10,
//       features: [
//         "🚀 Featured placement in app listings",
//         "📍 Local area promotion",
//         "🖼 Banner promotion & branding space",
//       ],
//       result:
//         "Free digital marketing support that drives real customer reach.",




//     },
//     {
//       title: "No Hardware & Zero Installation",
//       desc: "Manage your entire business seamlessly from any device — access orders, bookings, payments, and customer data anytime, anywhere, keeping you in control on the go.",
//       img: img11,
//       features: [
//         "📱 Smartphone",
//         "💻 Laptop",
//         "📟 Tablet or POS system",
//       ],
//       result:
//         "No servers, cables, maintenance, or IT installation required.",



//     },
//   ];



//   const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
//   const [expandedFeatures, setExpandedFeatures] = useState(
//     Array(sections.length).fill(false)
//   );

//   useEffect(() => {
//     const handleResize = () => setIsMobile(window.innerWidth < 768);
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const toggleFeature = (index) => {
//     const updated = [...expandedFeatures];
//     updated[index] = !updated[index];
//     setExpandedFeatures(updated);
//   };

//   const openSignup = () => {
//     setShowLogin(true);
//     setIsSignup(true);
//   };

//   return (
//     <div style={styles.container}>
//       {/* MAIN HEADER */}
//       <div style={styles.header}>
//         <motion.div
//           initial={{ opacity: 0, y: -20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.8 }}
//           style={{ position: "relative", display: "inline-block" }}
//         >
//           <p style={styles.mainHeading}>
//             Digital Presence That Builds  <span style={styles.highlight}>Trust & Expands Reach</span>
//           </p>
//           <motion.div
//             initial={{ width: 0 }}
//             animate={{ width: "70%" }}
//             transition={{ duration: 1, delay: 0.4, ease: "easeOut" }}
//             style={{
//               height: "2px",
//               background: "#e66d33",
//               borderRadius: "4px",
//               marginTop: "6px",
//               marginLeft: "auto",
//               marginRight: "auto",
//             }}
//           />
//         </motion.div>

//       </div>

//       {/* SECTIONS */}
//       <div style={styles.sectionsWrapper}>
//         {sections.map((section, index) => (
//           <motion.div
//             key={index}
//             initial={{ x: index % 2 === 0 ? -50 : 50, opacity: 0, scale: 0.95 }}
//             whileInView={{ x: 0, opacity: 1, scale: 1 }}
//             transition={{ duration: 0.7, ease: "easeOut", delay: index * 0.1 }}
//             viewport={{ once: true, margin: "-50px" }}
//             style={{
//               ...styles.sectionContainer,
//               marginBottom: index === sections.length - 1 ? "0" : "20px",
//               flexDirection: isMobile ? "column" : index % 2 === 0 ? "row" : "row-reverse",
//             }}
//           >
//             {/* IMAGE */}
//             <div style={styles.imageWrapper}>
//               <div style={styles.imageFrame}>
//                 <img src={section.img} alt={section.title} style={styles.sectionImage} loading="lazy" />
//                 <div
//                   style={{
//                     ...styles.imageDecoration,

//                   }}
//                 />
//               </div>
//             </div>

//             {/* CONTENT */}
//             <div style={styles.contentWrapper}>
//               <div style={styles.contentInner}>
//                 <div style={styles.titleRow}>
//                   <div
//                     style={{
//                       ...styles.titleIcon,
//                       background:
//                         index % 2 === 0
//                           ? "linear-gradient(135deg, #e66d33  0%, #e66d33  100%)"
//                           : "linear-gradient(135deg, #e66d33  0%, #e66d33  100%)",
//                     }}
//                   >
//                     <span style={styles.iconText}>{index + 1}</span>
//                   </div>
//                   <h2 style={styles.sectionTitle}>{section.title}</h2>
//                 </div>

//                 <p style={styles.sectionDescription}>{section.desc}</p>

//                 {/* BUTTONS */}
//                 <div style={{ display: "flex", gap: "12px", flexWrap: "wrap", marginTop: "auto" }}>

//                   <button
//                     style={{
//                       ...styles.signupBtn,
//                       background:
//                         index % 2 === 0
//                           ? "linear-gradient(135deg, #e66d33  0%, #e66d33  100%)"
//                           : "linear-gradient(135deg, #e66d33  0%, #e66d33  100%)",
//                       padding: isMobile ? "8px 14px" : "12px 22px",
//                       fontSize: isMobile ? "13px" : "16px",
//                       borderRadius: isMobile ? "6px" : "10px",
//                       fontWeight: "700",
//                     }}
//                     onClick={openDemo}
//                   >
//                     Explore<span style={styles.arrowBlink}>➜</span>
//                   </button>


//                   {/* KEY FEATURE BUTTON */}
//                   {/* <button
//                     style={{
//                       ...styles.signupBtn,
//                       background: "linear-gradient(135deg, #ff7a18 0%, #af002d 100%)",
//                       padding: isMobile ? "8px 14px" : "12px 22px",
//                       fontSize: isMobile ? "13px" : "16px",
//                       borderRadius: isMobile ? "6px" : "10px",
//                     }}
//                     onClick={() => toggleFeature(index)}
//                   >
//                     Key Features
//                   </button> */}
//                 </div>

//                 {/* EXPANDED FEATURES */}
//                 {expandedFeatures[index] && (
//                   <>
//                     <ul style={styles.featureList}>
//                       {section.features.map((feat, i) => (
//                         <li key={i} style={styles.featureItem}>
//                           {feat}
//                         </li>
//                       ))}
//                     </ul>

//                     {section.result && (
//                       <p style={styles.resultText}>
//                         <strong>Benefits:</strong> {section.result}

//                       </p>
//                     )}
//                   </>
//                 )}


//               </div>
//             </div>
//           </motion.div>
//         ))}
//       </div>
//     </div >
//   );
// };

// const styles = {
//   container: {
//     width: "100%",
//     minHeight: "100vh",
//     // backgroundColor: "#faf9ff",
//     padding: "60px 5%",
//     fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
//     position: "relative",
//     overflow: "hidden",
//   },
//   header: { textAlign: "center", marginBottom: "32px", marginTop: "0px", padding: "0 20px" },
//   mainHeading: { fontSize: "clamp(2.7rem, 5vw, 2.7rem)", fontWeight: "800", color: "#222", marginBottom: "20px", letterSpacing: "-1px", lineHeight: "1.1" },
//   highlight: { color: "#e66d33", backgroundClip: "text" },
//   subHeading: { fontSize: "clamp(1.1rem, 2vw, 1.3rem)", color: "#666", maxWidth: "1200px", margin: "0 auto", lineHeight: "1.6", fontWeight: "400", opacity: 0.9 },
//   sectionsWrapper: { maxWidth: "1400px", margin: "0 auto", padding: "20px 0" },
//   sectionContainer: { display: "flex", alignItems: "center", gap: "0px", width: "100%", minHeight: "400px", position: "relative" },
//   imageWrapper: { flex: "1", minWidth: "0", position: "relative" },
//   imageFrame: { position: "relative", height: "400px", overflow: "hidden", borderRadius: "25px" },
//   sectionImage: { width: "100%", height: "100%", objectFit: "contain", transition: "transform 0.6s ease" },
//   imageDecoration: { position: "absolute", top: "20px", left: "20px", right: "-20px", bottom: "-20px", borderRadius: "25px", opacity: 0.1, zIndex: -1, filter: "blur(10px)" },
//   contentWrapper: { flex: "1", minWidth: "0" },
//   contentInner: {
//     padding: "40px",
//     height: "100%",
//     display: "flex",
//     flexDirection: "column",
//     position: "relative", // <-- add this
//   },
//   titleRow: { display: "flex", alignItems: "center", gap: "20px", marginBottom: "25px" },
//   titleIcon: { width: "50px", height: "50px", borderRadius: "12px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, boxShadow: "0 8px 20px rgba(177, 92, 214, 0.2)" },
//   iconText: { color: "white", fontSize: "1.5rem", fontWeight: "700" },
//   sectionTitle: { fontSize: "clamp(1.8rem, 2.5vw, 2.2rem)", fontWeight: "800", color: "#222", margin: 0, letterSpacing: "-0.5px", lineHeight: "1.2" },
//   sectionDescription: { fontSize: "1.05rem", lineHeight: "1.8", color: "#555", marginBottom: "35px", flex: 1, fontWeight: "400" },
//   signupBtn: { border: "none", cursor: "pointer", display: "flex", alignItems: "center", gap: "12px", transition: "transform 0.3s ease", boxShadow: "0px 8px 15px rgba(0,0,0,0.15)" },
//   arrowBlink: { fontSize: "24px", fontWeight: "700", color: "#fff", animation: "arrowBlink 0.8s infinite alternate ease-in-out" },
//   featureList: { marginTop: "15px", paddingLeft: "20px" },
//   featureItem: { marginBottom: "6px", fontSize: "1rem", color: "#333", lineHeight: "1.5" },
// };

// export default DigitalMenuSection;




import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import axios from "axios";
import { useNavigate } from "react-router-dom";

// Import your images
import img0 from "../../images/reavanue.png";
import img1 from "../../images/trust.png";
import img2 from "../../images/cost.png";
import img3 from "../../images/digital.png";
import img4 from "../../images/notifaction.png";
import img5 from "../../images/reputaction.png";
import img6 from "../../images/globel.png";
import img7 from "../../images/sequrees.webp";
import img8 from "../../images/multiuser.png";
import img9 from "../../images/loyalty.png";
import img10 from "../../images/boots.png";
import img11 from "../../images/installment.png";

const DigitalMenuSection = ({ setShowLogin, setIsSignup, isLoggedIn, openDemo }) => {
  const sections = [
    {
      title: "Trusted Digital Presence, Wider Reach",
      desc: "Customers trust what they see online. A professional digital presence immediately improves credibility and decision-making.With Maamaas, your business gets a complete digital storefront that showcases:No need for website development, app building, designers, or technical knowledge.Everything is ready to use from Day 1.Maamaas makes every local business capable of competing with large brands — without heavy investment.",
      img: img1,
      features: [
        "Book services and order food in one app",
        "Plan events and travel",
        "Access multiple lifestyle services seamlessly",
        "Your brand identity and business information",
        "Product or service menus, pricing, and photos",
        "Real-time updates, offers, and announcements",
        "Customer reviews & direct communication",
        "A professional digital business profile",
        "Online visibility to reach more customers",
        "Instant messaging & direct engagement",
        "Improved trust and stronger brand identity",
        "More conversions and higher revenue"
      ],
    },
    {
      title: "Clear, Easy, Cost-Effective",
      desc: "Instead of commission loss, Maamaas offers a simple yearly subscription plan.No complicated charges. No fluctuating costs. One small yearly subscription for complete control.",
      img: img2,
      features: [
        "Complete digital storefront",
        "Order, booking & customer management",
        "Billing, payments & financial tracking tools",
        "Reviews, ratings & promotional features",
        "Analytics & performance insights",
        "Multi-user access for your business team",
      ],
    },
    {
      title: "Digital Billing. Live Payments.",
      desc: "Step into the future of business management with seamless digital billing. No more handwritten bills, missing records, or calculation mistakes.With Maamaas:",
      img: img3,
      features: [
        "Generate professional invoices instantly",
        "Auto-record every transaction safely in the cloud",
        "Maintain error-free financial history",
        "Export reports anytime for GST filing, audits, or accounts",
        "Track payments received / pending / cancelled",
      ],
      result: "Save time, reduce errors, and operate with complete transparency",
    },
    {
      title: "Instant Order Alerts",
      desc: "Stay connected to every customer moment — get instant alerts for orders, bookings, and inquiries whether you're online or offline, so no opportunity is ever missed.",
      img: img4,
      features: [
        "New customer orders",
        "Bookings & reservations",
        "Customer support inquiries",
        "Payment updates & status changes",
      ],
      result: "Faster response, zero delays, increased customer satisfaction.",
    },
    {
      title: "Real Reviews, Real Reputation",
      desc: "Let your work speak for itself — positive customer reviews build trust, boost visibility, and strengthen your business reputation so more people choose you with confidence.",
      img: img5,
      features: [
        "Honest reviews from real customers",
        "High ratings boost your ranking in search results",
        "Improves repeat customers & referrals",
        "Builds strong digital identity & credibility",
      ],
      result: "People choose businesses they trust — reviews make the difference.",
    },
    {
      title: "Business Analytics & Growth Insights",
      desc: "Make smarter business decisions with confidence — real-time insights and data analytics help you understand customer behavior, track performance, and plan the next move with clarity.",
      img: img6,
      features: [
        "Track sales daily, weekly, monthly",
        "Understand customer buying behaviour",
        "Identify best-selling items or services",
        "Know peak hours and demand seasons",
      ],
      result: "Smarter strategies, better planning, and higher profits.",
    },
    {
      title: "Flexible & Secure Payment Options",
      desc: "Offer customers complete payment flexibility — whether via UPI, cards, wallets, or net banking, transactions are fast, secure, and hassle-free every time.",
      img: img7,
      features: [
        "UPI / Cards / Wallets / Net Banking / COD",
        "Instant payment confirmation",
        "Zero payment confusion or disputes",
      ],
      result: "Faster payments = Faster business growth.",
    },
    {
      title: "Multi-User Access for Teams",
      desc: "Streamline staff management with digital tools — assign tasks, monitor performance, and stay in full control, all from one easy-to-use platform.",
      img: img8,
      features: [
        "👥 Add team members with role-based permissions",
        "🔒 Control access for security",
        "📝 Track logins, activities, and updates",
      ],
      result: "Perfect for restaurants, retail stores, salons, and service centers.",
    },
    {
      title: "Customer Loyalty & Promotional Tools",
      desc: "Boost customer loyalty by providing seamless experiences and personalized engagement, encouraging them to return again and again.",
      img: img9,
      features: [
        "🎁 Reward points & membership benefits",
        "🎉 Festival and seasonal promotions",
        "🏷 Coupons, discounts & offer codes",
        "📣 Boost engagement & increase lifetime customer value",
      ],
      result: "Enhance customer loyalty and maximize repeat business.",
    },
    {
      title: "Marketing & Local Discovery Boost",
      desc: "Get noticed and stay ahead of the competition — Maamaas increases your business visibility online, helping you reach more customers without extra marketing costs.",
      img: img10,
      features: [
        "🚀 Featured placement in app listings",
        "📍 Local area promotion",
        "🖼 Banner promotion & branding space",
      ],
      result: "Free digital marketing support that drives real customer reach.",
    },
    {
      title: "No Hardware & Zero Installation",
      desc: "Manage your entire business seamlessly from any device — access orders, bookings, payments, and customer data anytime, anywhere, keeping you in control on the go.",
      img: img11,
      features: [
        "📱 Smartphone",
        "💻 Laptop",
        "📟 Tablet or POS system",
      ],
      result: "No servers, cables, maintenance, or IT installation required.",
    },
  ];

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [expandedFeatures, setExpandedFeatures] = useState(
    Array(sections.length).fill(false)
  );

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleFeature = (index) => {
    const updated = [...expandedFeatures];
    updated[index] = !updated[index];
    setExpandedFeatures(updated);
  };

  const openSignup = () => {
    setShowLogin(true);
    setIsSignup(true);
  };

  return (
    <div style={styles.container}>
      {/* MAIN HEADER */}
      <div style={styles.header}>
        <div style={styles.headerContent}>
          <p style={styles.mainHeading}>
            Digital Presence That Builds{" "}
            <span style={styles.highlight}>Trust & Expands Reach</span>
          </p>
          <div style={styles.underline} />
        </div>
      </div>

      {/* SECTIONS */}
      <div style={styles.sectionsWrapper}>
        {sections.map((section, index) => (
          <div
            key={index}
            style={{
              ...styles.sectionContainer,
              marginBottom: index === sections.length - 1 ? "0" : isMobile ? "40px" : "10px",
              flexDirection: isMobile ? "column" : index % 2 === 0 ? "row" : "row-reverse",
            }}
          >
            {/* IMAGE */}
            <div style={styles.imageWrapper}>
              <div style={styles.imageFrame}>
                <img
                  src={section.img}
                  alt={section.title}
                  style={styles.sectionImage}
                  loading="lazy"
                />
              </div>
            </div>

            {/* CONTENT */}
            <div style={styles.contentWrapper}>
              <div style={styles.contentInner}>
                <div style={styles.titleRow}>
                  <div style={styles.titleIcon}>
                    <span style={styles.iconText}>{index + 1}</span>
                  </div>
                  <h2 style={styles.sectionTitle}>{section.title}</h2>
                </div>

                <p style={styles.sectionDescription}>{section.desc}</p>

                {/* BUTTONS */}
                <div style={styles.buttonGroup}>
                  <button style={styles.exploreBtn} onClick={openDemo}>
                    Explore <span style={styles.arrowBlink}>→</span>
                  </button>
                  
                  {/* <button
                    style={styles.featureBtn}
                    onClick={() => toggleFeature(index)}
                  >
                    {expandedFeatures[index] ? "Hide Features" : "Key Features"}
                  </button> */}
                </div>

                {/* EXPANDED FEATURES */}
                {expandedFeatures[index] && (
                  <>
                    <ul style={styles.featureList}>
                      {section.features.map((feat, i) => (
                        <li key={i} style={styles.featureItem}>
                          {feat}
                        </li>
                      ))}
                    </ul>

                    {section.result && (
                      <p style={styles.resultText}>
                        <strong>Benefits:</strong> {section.result}
                      </p>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Keyframe Animations */}
      <style>
        {`
          @keyframes arrowBlink {
            0% { transform: translateX(0); opacity: 1; }
            100% { transform: translateX(5px); opacity: 0.7; }
          }
          
          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          
          .benefit-card {
            animation: fadeInUp 0.5s ease forwards;
          }
        `}
      </style>
    </div>
  );
};

const styles = {
  container: {
    width: "100%",
    minHeight: "100vh",
    padding: "40px 20px",
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    position: "relative",
    overflow: "hidden",
    // background: "#faf9ff",
  },
  header: {
    textAlign: "center",
    marginBottom: "50px",
    marginTop: "0",
    padding: "0 16px",
  },
  headerContent: {
    maxWidth: "900px",
    margin: "0 auto",
  },
  mainHeading: {
    fontSize: "clamp(28px, 6vw, 48px)",
    fontWeight: "800",
    color: "#222",
    marginBottom: "20px",
    letterSpacing: "-0.5px",
    lineHeight: "1.2",
  },
  highlight: {
    color: "#e66d33",
    position: "relative",
    display: "inline-block",
  },
  underline: {
    height: "3px",
    width: "80px",
    background: "#e66d33",
    borderRadius: "4px",
    margin: "8px auto 0",
  },
  sectionsWrapper: {
    maxWidth: "1300px",
    margin: "0 auto",
    padding: "0",
  },
  sectionContainer: {
    display: "flex",
    alignItems: "center",
    gap: "40px",
    width: "100%",
    position: "relative",
  },
  imageWrapper: {
    flex: "1",
    minWidth: "0",
    position: "relative",
  },
  imageFrame: {
    position: "relative",
    height: "auto",
    overflow: "hidden",
    borderRadius: "20px",
    // background: "white",
    padding: "20px",
    // boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
  },
  sectionImage: {
    width: "100%",
    height: "auto",
    maxHeight: "350px",
    objectFit: "contain",
    display: "block",
    margin: "0 auto",
  },
  contentWrapper: {
    flex: "1",
    minWidth: "0",
  },
  contentInner: {
    padding: "20px",
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  titleRow: {
    display: "flex",
    alignItems: "center",
    gap: "15px",
    marginBottom: "20px",
    flexWrap: "wrap",
  },
  titleIcon: {
    width: "50px",
    height: "50px",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    background: "linear-gradient(135deg, #e66d33 0%, #e66d33 100%)",
    boxShadow: "0 8px 20px rgba(230, 109, 51, 0.2)",
  },
  iconText: {
    color: "white",
    fontSize: "1.5rem",
    fontWeight: "700",
  },
  sectionTitle: {
    fontSize: "clamp(22px, 3vw, 32px)",
    fontWeight: "800",
    color: "#222",
    margin: 0,
    letterSpacing: "-0.3px",
    lineHeight: "1.3",
    flex: 1,
  },
  sectionDescription: {
    fontSize: "clamp(14px, 2vw, 16px)",
    lineHeight: "1.7",
    color: "#555",
    marginBottom: "25px",
    fontWeight: "400",
  },
  buttonGroup: {
    display: "flex",
    gap: "12px",
    flexWrap: "wrap",
    marginTop: "auto",
    marginBottom: "20px",
  },
  exploreBtn: {
    background: "linear-gradient(135deg, #e66d33 0%, #e66d33 100%)",
    border: "none",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "12px 24px",
    fontSize: "15px",
    fontWeight: "700",
    borderRadius: "10px",
    color: "white",
    transition: "transform 0.2s ease",
    boxShadow: "0 4px 12px rgba(230, 109, 51, 0.3)",
  },
  featureBtn: {
    background: "transparent",
    border: "2px solid #e66d33",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "12px 24px",
    fontSize: "15px",
    fontWeight: "600",
    borderRadius: "10px",
    color: "#e66d33",
    transition: "all 0.2s ease",
    backgroundColor: "white",
  },
  arrowBlink: {
    fontSize: "18px",
    fontWeight: "700",
    color: "#fff",
    animation: "arrowBlink 0.8s infinite alternate ease-in-out",
    display: "inline-block",
  },
  featureList: {
    marginTop: "20px",
    paddingLeft: "20px",
    listStyle: "none",
  },
  featureItem: {
    marginBottom: "10px",
    fontSize: "clamp(13px, 1.8vw, 14px)",
    color: "#444",
    lineHeight: "1.6",
    paddingLeft: "24px",
    position: "relative",
  },
  resultText: {
    marginTop: "15px",
    fontSize: "clamp(13px, 1.8vw, 14px)",
    color: "#e66d33",
    lineHeight: "1.6",
    padding: "12px",
    background: "#fff5f0",
    borderRadius: "8px",
    fontWeight: "500",
  },
};

// Add hover styles with CSS
const styleSheet = document.createElement("style");
styleSheet.textContent = `
  button:hover {
    transform: translateY(-2px);
  }
  
  .explore-btn:hover {
    box-shadow: 0 6px 20px rgba(230, 109, 51, 0.4);
  }
  
  .feature-btn:hover {
    background: #e66d33;
    color: white;
  }
  
  @media (max-width: 768px) {
    .feature-item {
      font-size: 13px;
    }
  }
`;
document.head.appendChild(styleSheet);

export default DigitalMenuSection;
